import type { ReactNode } from "react";

type StatusKey = "石锤" | "实锤" | "存疑" | "反转";

export function statusStyle(status: string): {
  badge: string;
  dot: string;
} {
  const map: Record<StatusKey, { badge: string; dot: string }> = {
    石锤: {
      badge: "bg-primary-600 text-background-50",
      dot: "bg-background-50",
    },
    实锤: {
      badge: "bg-accent-100 text-accent-800 border border-accent-300",
      dot: "bg-accent-500",
    },
    存疑: {
      badge: "bg-secondary-100 text-secondary-800 border border-secondary-300",
      dot: "bg-secondary-400",
    },
    反转: {
      badge: "bg-background-50 text-foreground-700 border border-foreground-300",
      dot: "bg-foreground-400",
    },
  };
  return map[status as StatusKey] ?? map["存疑"];
}

export function StatusBadge({ status }: { status: string }) {
  const s = statusStyle(status);
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-semibold whitespace-nowrap ${s.badge}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${s.dot}`} />
      {status}
    </span>
  );
}

export function Eyebrow({ children }: { children: ReactNode }) {
  return (
    <span className="inline-flex items-center gap-2 text-sm font-semibold tracking-wide text-primary-700">
      <span className="inline-block h-2 w-2 bg-primary-500" />
      <span className="uppercase">{children}</span>
    </span>
  );
}

export function SectionHeading({
  eyebrow,
  title,
  desc,
  action,
}: {
  eyebrow: string;
  title: string;
  desc?: string;
  action?: ReactNode;
}) {
  return (
    <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between mb-8 md:mb-10">
      <div className="max-w-2xl">
        <Eyebrow>{eyebrow}</Eyebrow>
        <h2 className="mt-3 font-heading text-2xl md:text-4xl font-semibold leading-snug text-foreground-950">
          {title}
        </h2>
        {desc && (
          <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-600">
            {desc}
          </p>
        )}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}

export function chevronRight() {
  return (
    <i
      className="ri-arrow-right-line flex h-4 w-4 items-center justify-center text-sm"
      aria-hidden="true"
    />
  );
}